export const LABEL_DELETE_RESET = 'LABEL_DELETE_RESET'
export const LABEL_DELETE_SET_ERROR = 'LABEL_DELETE_SET_ERROR'
export const LABEL_DELETE_SET_DELETED = 'LABEL_DELETE_SET_DELETED'
export const LABEL_DELETE_TOGGLE_LOADING = 'LABEL_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/label/delete/mutation_types.js